/**
 * Manage image path requests using the
 * DatasourceManager's url templating system.
 **/ 
define('resource-path-manager/resource-path-manager',['require','exports','module','datasource-manager/lib/Datasource','datasource-manager/lib/extend','datasource-manager/env'],function(require,exports,module){
    var Datasource=require('datasource-manager/lib/Datasource'),
        extend = require('datasource-manager/lib/extend'),
        env = "env_" + require('datasource-manager/env')().toLowerCase();
    
    var STRING='string',
        PROD = "env_prod";

    function ResourcePathManager(){
        this.dscache = {};
        this.paths = {};
        this.collection = {};

    }
    ResourcePathManager.prototype={
        /**
         * Get a path from the set of paths with key/value replacement
         * @param  {string} id          Name of the path to get
         * @param  {object} [params]    Key/value pair for replaceing placeholders
         * @return {string}             Evaluated path.
         */
        get : function(id,params){
            var dscache = this.dscache,
                paths = this.paths,
                path;
            if(paths[id]){
                path = dscache[id];
                if(!path){
                    this.collection[id]={
                        urlTemplate : (typeof paths[id] === STRING) ? paths[id] : (paths[id][env] || paths[id][PROD])
                    };
                    path=dscache[id]=new Datasource(id,this.collection);
                }
                return path.getUrl(params||{});
            }
            return "";
        },
        /**
         * Add a path or set of paths
         * @param {mixed}   id      Id or set of id/path pairs.  Takes a string or object.
         * @param {string}  [_path] Path to set as id.  If id is a collection, _path is not needed.
         */
        set : function(id,_path){
            var key,
                path=id,
                path_ds={};

            if(typeof _path===STRING){
                path={};
                path[id]=_path;
            }
            for(key in id) {
                this.clearCacheForId(key);
            }
            extend(this.paths,path);
        },
        /**
         * Retrieve a raw path from the defined paths
         * @param  {string} id  Path to retrieve.
         * @return {mixed}      Path template or undefined (if not defined).
         */
        getTemplate : function(id) {
            return this.paths[id];
        },
        /**
         * Clear a compiled datasource from the cache. Useful if
         * there is an env switch.
         * @param  {string} id  Id of cached item to clear.
         * @return {boolean}    True if delete was successful, false it it was not.
         */
        clearCacheForId: function(id) {
            return delete this.dscache[id];
        }
    };

    return ResourcePathManager;
});

